import React, { useEffect } from 'react';
import './App.css';
import LandingPage from './components/LandingPage';
import { Analytics } from "@vercel/analytics/react"

function App() {
  useEffect(() => {
    // Track page view
    if (window.gtag) {
      window.gtag('config', 'GA_TRACKING_ID', {
        page_title: 'PopMart Auto-Checker Landing Page',
        page_location: window.location.href
      });
    }
    
    // Add smooth scrolling behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Preload Chrome Web Store page
    const link = document.createElement('link');
    link.rel = 'dns-prefetch';
    link.href = '//chrome.google.com';
    document.head.appendChild(link);
  }, []);

  return (
    <div className="App">
      <LandingPage />
      <Analytics />
    </div>
  );
}

export default App;